export default __webpack_public_path__ + "static/media/copy.5bc2a77c.svg";